import { atom } from 'recoil';

import type { NotificationTypes } from '@molecules/notificationBanner/NotificationBanner';

export type GlobalNotification = {
    type?: NotificationTypes;
    content?: string;
    isBlocking?: boolean;
    msBeforeDismiss?: number;
};

export const globalNotificationState = atom<GlobalNotification>({
    key: 'global-notification',
    default: {
        type: undefined,
        content: undefined,
        isBlocking: undefined,
        msBeforeDismiss: undefined,
    },
});
